export type FreelancerSubscriptionLike = {
  planTier?: string | null;
  status?: string | null;
  nextBillingDate?: string | null;
  endDate?: string | null;
};

const THERAPIST_PLAN_TIERS = ['STARTER', 'GROWTH', 'PROFESSIONAL'] as const;

export type TherapistPlanTier = (typeof THERAPIST_PLAN_TIERS)[number];

export function isFreelancerPlanTier(tier: string | null | undefined): boolean {
  if (!tier) return false;
  return THERAPIST_PLAN_TIERS.includes(tier as (typeof THERAPIST_PLAN_TIERS)[number]);
}

/** Any freelancer plan row in UserSubscription (any status — used to avoid paywall after cancel/expire). */
export function isFreelancerSubscriptionRecord(
  sub: FreelancerSubscriptionLike | null | undefined
): boolean {
  return isFreelancerPlanTier(sub?.planTier ?? null);
}

/** Paid access = ACTIVE UserSubscription with a therapist tier (Stripe trial is on the subscription in Stripe). */
export function isActiveFreelancerSubscription(
  sub: FreelancerSubscriptionLike | null | undefined
): boolean {
  if (!sub) return false;
  if (sub.status !== 'ACTIVE') return false;
  if (!isFreelancerPlanTier(sub.planTier)) {
    return false;
  }
  const now = new Date();
  if (sub.nextBillingDate && new Date(sub.nextBillingDate) < now) return false;
  if (sub.endDate && new Date(sub.endDate) < now) return false;
  return true;
}
